import React, {useContext, useState} from "react";
import {Page, PatientInfo} from "./types";
import {ActionContext, ActionType} from "../components/hooks/provider";
import Form from "../components/form/form";
import moment from "moment";
import {LangManager} from "../components/i18n/langManager";

interface IProps {
    patientInfo: PatientInfo
}

export default function BirthdayPage(props: IProps) {
    const {dispatchActionState, actionState} = useContext(ActionContext)
    const [submitted, setSubmitted] = useState(false)
    const [dob, setDob] = useState("")

    const langManager = LangManager(actionState.language)
    const $title = (
        <p className={"text-black text-base font-medium leading-5"}>{`${langManager.onlineCheckin} ${props.patientInfo.name}`}</p>
    )

    const $description = (
        <div className={"w-full h-max bg-[#EEF3F9] flex flex-col my-4"}>
            <p className={"text-sm text-[#365496] leading-5"}>{langManager.helpVerify}
                {<span className={"text-black"}>{langManager.birthdayDesc}</span>}
            </p>
        </div>
    )

    const onContinue = () => {
        setSubmitted(true)
        if (!dob.length) {
            return
        }
        if (props.patientInfo.patientDOB === dob) {
            dispatchActionState({type: ActionType.page, value: Page.profile})
        } else {
            dispatchActionState({type: ActionType.page, value: Page.verifyFailed})
        }
    }

    const $buttons = (
        <div className={"w-full grid grid-cols-2 space-x-5 mt-6"}>
            <button onClick={() => {
                dispatchActionState({type: ActionType.page, value: Page.contact})
            }} type={"button"} className={" py-3 px-2 text-primary font-medium bg-white border-2 border-primary rounded-xl"}>
                {langManager.back}
            </button>

            <button type={"button"} onClick={() => {
                onContinue()
            }} className={"py-3 px-2 text-white font-medium bg-primary rounded-xl"}>
                {langManager.continue}
            </button>
        </div>
    )
    const errMsgForDob = submitted && !dob.length ? langManager.pleaseFillField : ""
    const maxDate = moment().format("YYYY-MM-DD")
    const $dob = (
        <Form max={maxDate} errMsg={errMsgForDob} type={"date"} placeholder={"MM/DD/YYYY"} title={langManager.dateOfBirth} value={dob} onChangeText={(text) => {
            setDob(text)
        }} />
    )
    return (
        <div className={"w-full"}>
            <div className={"w-full bg-white px-5 pt-4 pb-10"}>
                {$title}
                {$description}
                {$dob}
                {$buttons}
            </div>
        </div>
    )
}
